import enumerateDaysBetweenDates from '../../components/Training/utils/periodUtil';

export default function generateDays(startDate, endDate) {
  return enumerateDaysBetweenDates(startDate, endDate).map((date) => ({
    date: date.valueOf(),
    perdiems: []
  }));
}
